import React from 'react';
import { styled } from '@compiled/react';
import StarStarredIcon from '@atlaskit/icon/core/migration/star-starred--star-filled';

export const StarredHeader = ({ label }: { label: string }) => (
	<ContentWrapper>
		<StarStarredIcon color="currentColor" label={label} LEGACY_size="small" />
	</ContentWrapper>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ContentWrapper = styled.div({
	display: 'flex',
	justifyContent: 'center',
});
